<template>
  <footer>
    <div class="information">
      <div
        class="contact-us"
        aria-label="Contact Us"
        role="contentinfo"
      >
        <h2>
          CONTACT US
        </h2>
        <div>
          <LocationSvg />
          <div class="address">
            42655 State Route 18 <br> Wellington, OH 44090
          </div>
        </div>
        <div>
          <EmailSvg />
          <a href="mailto:sales@shortactioncustoms.com">
            sales@shortactioncustoms.com
          </a>
        </div>
        <div>
          <PhoneSvg />
          <a
            href="tel:4403090085"
            style="margin-bottom: 3rem"
          >
            440-309-0085
          </a>
        </div>
      </div>
      <div
        aria-label="Hours"
        role="contentinfo"
      >
        <h2>
          HOURS
        </h2>
        <p>
          Mon - Fri: 7:00 a.m. - 3:00 p.m. EST<br>
          Sat &amp; Sun: Closed
        </p>
        <p>
          Appointment Only Please!
        </p>
      </div>
      <div
        aria-label="Services"
        role="contentinfo"
      >
        <h2>
          SERVICES
        </h2>
        <ul>
          <li>
            <a href="https://shortactioncustoms.com/action-bolt-services/">Action &amp; Bolt Services</a>
          </li>
          <li>
            <a href="https://shortactioncustoms.com/barrel-services/">Barrel Services</a>
          </li>
          <li>
            <a href="https://shortactioncustoms.com/build-your-rifle/">Build Your Rifle</a>
          </li>
          <li>
            <a href="https://shortactioncustoms.com/stock-refinishing-services/">Stock &amp; Refinishing Services</a>
          </li>
        </ul>
      </div>
      <div
        class="follow-us"
        aria-label="Social Media Links"
        role="contentinfo"
      >
        <h2>
          FOLLOW US
        </h2>
        <div>
          <a
            aria-label="Open Short Action Customs' Facebook Page (opens in a new window)"
            target="_blank"
            href="https://www.facebook.com/Shortactioncustoms/"
          >
            <FacebookSvg />
          </a>
        </div>
        <div>
          <a
            aria-label="Open Short Action Customs' Instagram Page (opens in a new window)"
            target="_blank"
            href="https://www.instagram.com/shortactioncustoms"
          >
            <InstagramSvg />
          </a>
        </div>
        <div>
          <a
            aria-label="Open Short Action Customs' Youtube Page (opens in a new window)"
            target="_blank"
            href="https://www.youtube.com/user/ShortActionCustoms"
          >
            <YoutubeSvg />
          </a>
        </div>
      </div>
      <div
        class="links"
        aria-label="Short Action Customs' Links"
        role="contentinfo"
      >
        <a
          class="link"
          href="https://shortactioncustoms.com/privacy-policy/"
        >
          PRIVACY POLICY
        </a>
        <a
          class="link"
          href="https://shortactioncustoms.com/terms-and-conditions/"
        >
          TERMS &amp; CONDITIONS
        </a>
        <a
          class="link"
          href="https://shortactioncustoms.com/returns-and-guarantee/"
        >
          RETURNS &amp; GUARANTEE
        </a>
      </div>
    </div>
    <div
      class="copyright"
      aria-label="Copyright"
      role="contentinfo"
    >
      {{ copyrightText }}
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import EmailSvg from "@/components/svgs/EmailSvg.vue"
import FacebookSvg from '@/components/svgs/FacebookSvg.vue'
import InstagramSvg from '@/components/svgs/InstagramSvg.vue'
import LocationSvg from "@/components/svgs/LocationSvg.vue"
import PhoneSvg from '@/components/svgs/PhoneSvg.vue'
import YoutubeSvg from '@/components/svgs/YoutubeSvg.vue'

export default defineComponent({
  components: {
    EmailSvg,
    FacebookSvg,
    InstagramSvg,
    LocationSvg,
    PhoneSvg,
    YoutubeSvg
  },
  computed: {
    copyrightText(): string {
      return `Short Action Customs, LLC. © ${new Date().getFullYear()}. All rights reserved.`
    }
  }
})
</script>

<style scoped lang="scss">

footer {
  background-color: #1f1f1d;
  text-align: center;

  > .information {
    padding: 32px 15px;
    display: grid;

    @include tablet {
      grid-template-rows: 3fr;
      grid-template-columns: repeat(2, 1fr);
    }

    @include desktop {
      padding: 32px 25px;
      grid-template-rows: 1fr;
      grid-template-columns: repeat(5, 1fr);
    }

    > div {
      margin-bottom: 30px;

      @include desktop {
        margin-bottom: 0;
      }

      &.contact-us {
        > div {
          color: $Color-white;
          font-size: 16px;
          font-weight: 300;
          margin-bottom: 1em;
        }

        svg {
          fill: $Color-white;
          width: 16px;
          height: 16px;
        }

        .address {
          display: inline-flex;
          margin-left: 12px;
        }

        a {
          color: $Color-white;
          margin-left: 8px;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: $Color-sac-orange;
          }
        }
      }

      p {
        color: $Color-white;
      }

      a.link {
        display: block;
        font-weight: bold;
        color: $Color-white;
        text-decoration: none;
        margin-bottom: 1.45em;
        font-size: 16px;
        font-weight: bold;
        transition: color 0.3s ease;

        &:hover {
          color: $Color-sac-orange;
        }
      }

      &.follow-us {
        > div {
          display: inline-block;
          margin-right: 6px;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background-color: #10100f;
          transition: background-color 0.3s ease;

          &:hover {
            background-color: $Color-sac-orange;

            > a > svg {
              fill: $Color-white;
            }
          }

          > a {
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            &:last-of-type {
              margin-right: 0;
            }

            > svg {
              width: 16px;
              height: 16px;
              fill: #949493;
            }
          }
        }
      }

      &.links {
        margin-bottom: 0;
      }

      > ul {
        padding-left: 1.2em;
        list-style-type: none;

        > li {
          position: relative;

          + li {
            margin-top: 0.56em;
          }

          > a {
            color: $Color-white;
            font-size: 16px;
            line-height: 23.52px;
            font-weight: 300;
            text-decoration: none;
            transition: color 0.3s ease;

            &:hover {
              color: $Color-sac-orange;
            }
          }
        }
      }

      > h2 {
        color: $Color-white;
        margin: 0 0 0.95em 0;
        font-size: 1.5em;
        line-height: 1.58;
        font-weight: bold;
      }
    }
  }

  > .copyright {
    background-color: #10100f;
    color: $Color-white;
    font-size: 16px;
    text-align: center;
    font-weight: 300;
    padding: 25px 0;
  }
}

</style>
